module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "marketing-overview"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('LineTipsComponent', {
    staticStyle: {
      "width": "20%",
      "margin-top": "33px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _c('columnar-component', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "columnarData": _vm.columnarData
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49111dc4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/indexData/components/productAnalysis/ProductAnalysis.vue
// module id = 831
// module chunks = 0